export const KEYS = {
  TERRITORIAL_DASHBOARD_TUTORIAL: 'territorial_dashboard_tutorial',
} as const;
